export const slipMapper = [
  {
    sectionName: 'Luminaires',
    slipLevel: 1,
    gridSize: 4,
  },
  {
    sectionName: 'Matches',
    slipLevel: 2,
    gridSize: 4,
  },
  {
    sectionName: 'Selections',
    slipLevel: 3,
    gridSize: 4,
  },
  // {
  //   sectionName: ' ',
  //   slipLevel: -1,
  //   gridSize: 4,
  // },
  {
    sectionName: 'Discarded',
    slipLevel: 0,
    gridSize: 6,
  },
  {
    sectionName: 'Archived',
    slipLevel: 4,
    gridSize: 6,
  },
];
